// extracted by mini-css-extract-plugin
export default {"categories":"ProductsNotFound_categories__-xX10"};